/** @format */

import axios from 'axios';

import Notify from '../../../Commons/Notify';

import { ENV_SCHEDULE, ENV_COUNTRY } from '../../../Commons/Hooks/Variables/Enviroment';

const PharmacyScheduleFunction = async (Pharmacy, Local, checkout) => {
	let returnResponse;
	await axios({
		method: 'POST',
		url: `${ENV_SCHEDULE}/locals-schedule/${ENV_COUNTRY}`,
		data: {
			pharmacy: Pharmacy,
			local: Local,
			km_distance: parseFloat(checkout.shipping_information.distance),
			order_type: checkout.info.type_retirement,
		},
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				returnResponse = response.data.data;
			} else {
				Notify({
					title: `Error: ${response.data.statusCode}`,
					colorTitle: 'ph-main-notification-error-title',
					description: `Problemas con la Function:  pharmacy - schedule, ${response.data.message}`,
					time: 3,
					image: 'error',
					placement: 'topRight',
				});
			}
		})
		.catch((error) => {
			console.log(error);
			// Notify({
			// 	title: 'Problemas de Conexión',
			// 	colorTitle: 'ph-main-notification-error-title',
			// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
			// 	time: 3,
			// 	image: 'error',
			// 	placement: 'topRight',
			// });
		});
	return returnResponse;
};
export default PharmacyScheduleFunction;
